module.exports = __webpack_public_path__ + "img/bitmap_reward@3x.e582ef05.png";